import {
  OnboardingResponse,
  OnboardingServices,
  OnboardingValidateFail,
  OnboardingValidatorSchema,
  OnboardingValidatorServiceMethods,
} from 'clickNgo/configs/service/onboarding'
import { WebSocketStoreKeys } from 'clickNgo/configs/service/ws'
import { getAccessToken } from 'cng-common/helpers/access'
import WebSocketStore from 'core/classes/services/WebSocketStore'

type ValidateAsyncPayload<T = object> = {
  object: T
  schemaId: OnboardingValidatorSchema
}

export function validateAsync(payload: ValidateAsyncPayload) {
  const token = getAccessToken()
  const wsClient = WebSocketStore.get(WebSocketStoreKeys.Onboarding)

  return wsClient.call({
    service: OnboardingServices.Validator,
    action: OnboardingValidatorServiceMethods.Validate,
    payload,
    token: token || undefined,
    withoutTokenRefresh: true,
    isAuth: true,
    returnError: true,
  }) as Promise<OnboardingResponse<OnboardingValidateFail>>
}
